import { useTranslation } from 'react-i18next';
import type { ProductType } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'brand';

/** One place decides what colour each product type wears across every screen. */
const TYPE_TONES: Record<ProductType, Tone> = {
  FRAME: 'brand',
  SUNGLASSES: 'warning',
  PRESCRIPTION_LENS: 'success',
  CONTACT_LENS: 'success',
  SOLUTION: 'neutral',
  ACCESSORY: 'neutral',
};

export function ProductTypeBadge({ type }: { type: ProductType }) {
  const { t } = useTranslation();

  return <Badge tone={TYPE_TONES[type] ?? 'neutral'}>{t(`catalog.types.${type}`)}</Badge>;
}
